module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.logo,
      "alt": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00e826fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Logo.vue
// module id = 1062
// module chunks = 0